<nf-grid-wrapper>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Portfolios and Simples</h2>
    <small *ngIf="selectedAggregateAccount">
      <button
        nf-icon-button="danger"
        icon="close-circle-outline"
        class="btn-bare"
        ngbTooltip="Remove Account"
        placement="bottom-right"
        (click)="this.clearSelectedAggregateAccount()"
      ></button>
      {{ filterTypeLabel }}:
      {{ selectedAggregateAccount.accountName | truncate: 50 }}
    </small>
  </nf-grid-wrapper-header-left>

  <ng-grid-wrapper-header-right>
    <div class="header-toolbar-item">
      <input
        type="text"
        id="quick-search"
        class="form-control"
        [formControl]="quickSearch"
        placeholder="Search table..."
      />
    </div>
  </ng-grid-wrapper-header-right>

  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-ag-grid
      [autoResize]="false"
      [gridOptions]="gridOptions"
      [gridModules]="gridModules"
    ></nf-ag-grid>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
